import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams, useOutletContext } from 'react-router-dom';

import BreadcrumbTrail from '../../../../layouts/BreadcrumbTrail';
import CenteredLoader from '../../../../components/loaders/PageLoader';
import UnitVersionTable from '../../components/UnitVersion/UnitVersionTable';

import styles from './UnitVersion.styles';
import { useCrumb } from '../../../../layouts/TrailProvider';
import { useUnitVersions } from '../../hooks/useUnitVersions';

export default function UnitVersion() {
  const { isSidebarExpanded } = useOutletContext();
  const { unitName } = useParams();

  useCrumb('History', `/home/units/${encodeURIComponent(unitName)}/history`);

  const { loading, versions } = useUnitVersions(unitName);

  return (
    <Box
      sx={{
        ...styles.versionDetails,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      <BreadcrumbTrail />

      <Box sx={styles.headerRow}>
        <Typography sx={styles.pageTitle}>
          Unit History – {unitName}
        </Typography>
      </Box>

      {loading ? (
        <CenteredLoader />
      ) : (
        <UnitVersionTable rows={versions} />
      )}
    </Box>
  );
}
